import React, { useEffect, useState } from 'react';
import { MapPin, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Pinboard',
    href: '#features'
  }, {
    name: 'Fieldbook',
    href: '#features'
  }, {
    name: 'Terrain Tools',
    href: '#features'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-parchment/95 backdrop-blur-sm shadow-md py-3 border-b border-brown/10' : 'bg-transparent py-5'}`} data-id="element-153">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-154">
        <div className="flex justify-between items-center" data-id="element-155">
          {/* Logo */}
          <div className="flex items-center space-x-2 group cursor-pointer" data-id="element-156">
            <div className="relative" data-id="element-157">
              <MapPin className="h-8 w-8 text-terracotta transform group-hover:-translate-y-1 transition-transform duration-300" data-id="element-158" />
              <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-4 h-1 bg-black/20 rounded-full blur-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-159" />
            </div>
            <span className="text-2xl font-serif font-bold text-forest tracking-tight" data-id="element-160">
              Maplekeep
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-161">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-forest/80 hover:text-terracotta font-medium transition-colors duration-200 font-sans" data-id="element-162">
                {link.name}
              </a>)}
            <button className="bg-forest text-parchment px-6 py-2.5 rounded-sm font-serif font-bold hover:bg-forest-light transition-colors duration-300 shadow-sm border border-forest/20" data-id="element-163">
              Start Exploring
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-164">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-forest hover:text-terracotta transition-colors" data-id="element-165">
              {isMobileMenuOpen ? <X size={24} data-id="element-166" /> : <Menu size={24} data-id="element-167" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-168">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-parchment border-b border-brown/20 overflow-hidden" data-id="element-169">
            <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-170">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-3 text-forest hover:bg-brown/10 rounded-md font-medium transition-colors" data-id="element-171">
                  {link.name}
                </a>)}
              <div className="pt-4" data-id="element-172">
                <button className="w-full bg-forest text-parchment px-6 py-3 rounded-sm font-serif font-bold hover:bg-forest-light transition-colors shadow-sm" data-id="element-173">
                  Start Exploring
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}